<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Eixos</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Listagem de Eixos"
            api-url="eixos/list"
            report-title="Eixos"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'eixos'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="custom-font" for="EIX_DCEIXO_filter"
                    >Descrição</label
                  >
                  <input
                    type="text"
                    v-model="EIX_DCEIXO"
                    class="form-control"
                    name="DAD_DCNOME_filter"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'admin_eixos_save' }"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon> Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </button>
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import request from '@/request'

export default {
  inject: ['showConfirm'],
  name: 'eixos',
  data() {
    return {
      fields: [
        {
          name: 'EIX_DCEIXO',
          title: 'Nome',
          sortField: 'EIX_DCEIXO',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {},
  methods: {
    editar(data) {
      this.$router.push({
        name: 'admin_eixos_save',
        params: { id: data.EIX_IDEIXO, name: data.EIX_DCEIXO }
      })
    },
    excluir(data) {
      var dt = this.$refs.vuetable
      data.type = 'EIXO'

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request.delete(
            data,
            () => {
              dt.refresh()
            },
            () => {
              console.log(
                'houve um error ao tentar excluir este item, por favor tente novamente mais tarde!'
              )
            }
          )
        }
      }
      this.showConfirm('Deseja realmente deletar este item?', config)
    },
    consultar() {
      this.$refs.vuetable.refresh()
    },
    limpar() {
      this.EIX_DCEIXO = ''
      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'eixos',
        value: 1
      })
    }
  },
  computed: {
    filtros() {
      const { EIX_DCEIXO } = this
      return {
        EIX_DCEIXO
      }
    },
    pagina: {
      get() {
        const { eixos } = this.$store.state.vuetableState
        const { pagina } = eixos
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'eixos',
          value: value
        })
      }
    },
    EIX_DCEIXO: {
      get() {
        const { eixos } = this.$store.state.vuetableState
        const { EIX_DCEIXO } = eixos.filtros

        return EIX_DCEIXO
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'EIX_DCEIXO',
          collection: 'eixos',
          value: value
        })
        this.resetPageStore()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/eixos/index.vue